// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__fRtbv","logo":"Error_logo__hxUcL","back":"Error_back__c8RMZ"};